/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import CrucigramaPanel from './CrucigramaPanel';
import * as validations from '../../validations/validations';
import * as crucigramaActions from '../../actions/crucigramaActions';

import {  useParams } from "react-router-dom";
import {  useLocation, useNavigate  } from "react-router-dom";
import withRouter from '../common/withRouter';


import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes,usuarioActual} from '../../util/';
 import $ from 'jquery';


class ManageCrucigramaForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
			crucigrama:{
                    }
		};
		
	}
    
    
    componentDidMount(){
        
        /*
        let id=this.props.id;
        let pageInfo={ 
            page:'crucigrama', 
            idioma:this.props.idioma     
        };
        */
        //this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);  
        /*
        this.props.paginaActions.getInfo(pageInfo, this.props.user).then( pageInfoResponse=>{ 
            this.setState({"permisos":pageInfoResponse.permisos, 
                            "strings":Object.assign({}, pageInfoResponse.strings)}); 
        }).catch(error=>{ 
          toastr.error(error); 
        });
        */
        let id=this.props.id;
        usuarioActual(this, "crucigrama",true).then( (usuario)=>{
        
            if(id && id>0 ){

               this.props.crucigramaActions.getCrucigrama(id, usuario).then( crucigrama=>{
                   this.setState({"crucigrama":crucigrama});
               })
                .catch(error=>{
                  toastr.error(error);
                }); 
            }
         })
        .catch(error=>{
          toastr.error(error);
        });
		
    }
    

    handleChange=(event, data)=> {

        let crucigrama = this.state.crucigrama;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		crucigrama[field[0]]= value;
		else{
             if(!crucigrama[field[0]]){
                    crucigrama[field[0]]={}
                }
			crucigrama[field[0]][field[1]]= value;
		}
        
		
        this.setState({"crucigrama": crucigrama});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let crucigrama=this.state.crucigrama;
              
        if(!validations.requerido(crucigrama.nombre)){
            errors.nombre=true;
            formIsValid=false;
        }
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }



    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        
        this.props.crucigramaActions.save(this.state.crucigrama, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
            this.props.navigate(-1);
        });
        
    }

       
    render() {	
        let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
        return (
              <Segment  style={margenes}>
                <CrucigramaPanel 
                    strings={this.props.strings}    
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.crucigrama}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
        color:state.color,
        user:state.user, 
        idioma:state.idioma,
        form:state.form,
        strings:state.strings
    }

}

function mapDispatchToProps(dispatch){

	return {   
            showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
            paginaActions: bindActionCreators(paginaActions, dispatch),
            crucigramaActions: bindActionCreators(crucigramaActions, dispatch),
            userActions: bindActionCreators(userActions, dispatch)
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageCrucigramaForm));